import { Outlet, Navigate } from "react-router";
import { getAuthToken } from "../../helpers";
import { Navbar } from "../Navigation/Navbar";

export const AdminLayout = () => {
  // const navigate = useNavigate();

  if (!getAuthToken()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50 overflow-x-hidden">
      <Navbar />
      <main className="px-5 md:px-11 py-6 md:py-8 max-w-[2000px] mx-auto">
        <Outlet />
      </main>
    </div>
  );
};
